// packages/core-docs/src/mocks/cdn-translations.ts
export const useRequestTranslations = (
  config: any,
  nonstandardTranslations: any,
  { oldTranslations, enableCDN }: { oldTranslations: any; enableCDN: boolean }
) => ({
  status: 'resolved',
  translations: oldTranslations || {},
})

export const getFallbackList = (locale: string) => [locale]

export const isCDNFeatureFlagEnabled = () => false
